import React from "react";
import "./Network.css";
import mainImage from "../Assets/iotnet..jpeg"; // Replace with your main image
import step1Image from "../Assets/iotnet1.jpeg"; // Replace with your step 1 image
import step2Image from "../Assets/iotnet3.jpeg"; // Replace with your step 2 image
import step3Image from "../Assets/iot net5.jpeg"; // Replace with your step 3 image
import step4Image from "../Assets/iotnet6.jpeg"; // Replace with your step 4 image
import step5Image from "../Assets/iotnet4.jpeg"; // Replace with your step 5 image

function Network() {
  return (
    <div className="network-container">
      {/* Main Section */}
      <div className="main-section">
        <img src={mainImage} alt="Main Background" className="main-image" />
        <div className="main-overlay">
          <h1>Smart Network Solutions</h1>
          <p>
            IoT network technology enables seamless device communication,
            <br /> driving real-time data exchange and automation across industries.
          </p>
        </div>
      </div>

      {/* Section Divider */}
      <div className="divider">HOW WE ROCK & ROLL</div>

      {/* Steps Section */}
      <div className="steps-section">
        {/* Step 1 */}
        <div className="step-row left-align">
          <img src={step1Image} alt="Step 1" className="step-image" />
          <div className="step-content">
            <h3>Global System for Mobile Communications</h3>
            <p>
              GSM is a standard developed to ensure mobile communication between different mobile devices and networks. It is widely used for 2G mobile networks, providing services like voice calls, text messaging, and data transmission.
            </p>
          </div>
        </div>

        {/* Step 2 */}
        <div className="step-row right-align">
          <div className="step-content">
            <h3>General Packet Radio Service</h3>
            <p>
              GPRS is a mobile data service that provides packet-switched data transfer over cellular networks. It allows for the transmission of data such as internet browsing, email, and multimedia messaging, enabling mobile devices to access the internet and other data services.
            </p>
          </div>
          <img src={step2Image} alt="Step 2" className="step-image" />
        </div>

        {/* Step 3 */}
        <div className="step-row left-align">
          <img src={step3Image} alt="Step 3" className="step-image" />
          <div className="step-content">
            <h3>Fourth Generation Long-Term Evolution</h3>
            <p>
              4G LTE is a high-speed wireless communication technology that provides faster data transfer rates and improved network performance compared to earlier generations like 3G. It supports services like HD video streaming, fast internet browsing, and real-time gaming on mobile devices.
            </p>
          </div>
        </div>

        {/* Step 4 */}
        <div className="step-row right-align">
          <div className="step-content">
            <h3>Narrowband Internet of Things.</h3>
            <p>
            NB-IoT is a low-power, wide-area network technology designed to support IoT devices with low data rates, extended battery life, and wide coverage. It is ideal for applications like smart meters, asset tracking, and environmental monitoring.
            </p>
          </div>
          <img src={step4Image} alt="Step 4" className="step-image" />
        </div>

        {/* Step 5 */}
        <div className="step-row left-align">
          <img src={step5Image} alt="Step 5" className="step-image" />
          <div className="step-content">
            <h3> Fifth Generation</h3>
            <p>
            5G is an advanced wireless communication technology that offers ultra-fast data speeds, low latency, and massive connectivity for IoT devices. It is set to revolutionize industries with applications in smart cities, autonomous vehicles, and real-time healthcare. It is an upcoming innovation soon to be introduced in our company to enhance connectivity and solutions.







            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Network;
